import { getShortMonthDateObj, getMassTimeAMPM } from "../../../utils/utils";

export const displayBookingDisabledMessage = (
  schedule,
  isPreview = false,
  user = false
) => {
  const { available, startDate, endDate, bookingStartDate, bookingEndDate } =
    schedule;
  const now = new Date();
  const nowTime = now.getTime();
  // Event is over
  if (nowTime > endDate.getTime()) {
    return "Event has ended";
  }

  if (nowTime > startDate.getTime()) {
    return "Event has started";
  }
  if (!isPreview && nowTime > bookingEndDate.getTime()) {
    return "Booking has closed";
  }

  if (!isPreview && available === 0) {
    return "Event capacity is full";
  } else if (nowTime < bookingStartDate.getTime()) {
    const bookingStartStr =
      bookingStartDate.getDate() +
      " " +
      getShortMonthDateObj(bookingStartDate) +
      " " +
      bookingStartDate.getFullYear() +
      " at " +
      getMassTimeAMPM(bookingStartDate);

    return `Booking opens on ${bookingStartStr}`;
  }

  // User is not logged in
  if (!user) {
    return "You need to be logged in to book";
  }

  return false;
};

export const checkOrgRestriction = (event, parish) => {
  if (
    !event?.orgRestrictions ||
    event?.orgRestrictions?.length === 0 ||
    event?.orgRestrictions?.includes(parish)
  ) {
    return true;
  }
};

export function getBasicEventDetails(event) {
  return {
    available: event.available || "",
    bookingStartDate: event.bookingStartDate || "",
    bookingEndDate: event.bookingEndDate || "",
    capacity: event.capacity || "",
    createdAt: event.createdAt || "",
    eventId: event.eventId || "",
    eventLocation: event.eventLocation || "",
    eventName: event.eventName || "",
    eventImage: event.eventImage || "",
    eventOrgName: event.eventOrgName || "",
    eventVenue: event.eventVenue || "",
    orgId: event.orgId || "",
    parentEventId: event.parentEventId || "",
    publishedBy: event.publishedBy || "",
    startDate: event.startDate || "",
    endDate: event.endDate || "",
  };
}
